import { BaseError } from './common/BaseError';
/**
 * Use to signal about errors which shouldn't be appears.
 * This error means some problems with code.
 * E.g if some function should work with some node but this node isn't existed in the nodes DSL. That means function was called incorrectly.
 */
export class SystemError extends BaseError {
}
